import { autoinject } from "aurelia-dependency-injection";
import { ConfigService } from "./config.service";
import { GetCustomerSubscriptionResponse } from "../../models/rightstore/rightstore.models";
import { RequestClientService } from "./request-client.service";

@autoinject()
export class CustomerSubscriptionService {

    public platformUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}`
    public getCustomerSubscriptionPromiseCache: { [productCode: string]: Promise<GetCustomerSubscriptionResponse> } = {};

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    async getMySubscription(productCode: string, reload: boolean = false): Promise<GetCustomerSubscriptionResponse> {
        if (this.getCustomerSubscriptionPromiseCache[productCode] && !reload) {
            return await this.getCustomerSubscriptionPromiseCache[productCode];
        }

        this.getCustomerSubscriptionPromiseCache[productCode] = this.requestClientService.get<GetCustomerSubscriptionResponse>(`${this.platformUrl}/customerSubscription/GetMySubscription`, { productCode });
        return await this.getCustomerSubscriptionPromiseCache[productCode];
    }
}